<template>
	<div class="section container-fluid" id="privacy">
		<div class="row inner">
			<div id="main" class="col-xs-12">
				<h2 data-aos="fade-in">Privacy Policy<mark>.</mark></h2>
				<div data-aos="flip-left" data-aos-delay="50" class="line"></div>
				<p>
					Last updated July 05, 2020
					<br>
					<br>

					Thank you for choosing to be part of our community at Edvard.dev (“Company”, “we”, “us”, or “our”). We are committed to protecting your personal information and your right to privacy. If you have any questions or concerns about this privacy notice, or our practices with regards to your personal information, please contact us at me@edvard.dev.
					<br/>
					<br/>
					When you visit our website https://edvard.dev (the "Website"), and more generally, use any of our services (the "Services", which include the Website), we appreciate that you are trusting us with your personal information. We take your privacy very seriously. In this privacy notice, we seek to explain to you in the clearest way possible what information we collect, how we use it and what rights you have in relation to it. We hope you take some time to read through it carefully, as it is important. If there are any terms in this privacy notice that you do not agree with, please discontinue use of our Services immediately.
					<br/>
					<br/>
					This privacy notice applies to all information collected through our Services (which, as described above, includes our Website), as well as any related services, sales, marketing or events.
					<br/>
					<br/>
					Please read this privacy notice carefully as it will help you understand what we do with the information that we collect.
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					TABLE OF CONTENTS
					<br/>
					<br/>
					1. WHAT INFORMATION DO WE COLLECT?
					<br/>
					<br/>
					2. HOW DO WE USE YOUR INFORMATION?
					<br/>
					<br/>
					3. WILL YOUR INFORMATION BE SHARED WITH ANYONE?
					<br/>
					<br/>
					4. WHO WILL YOUR INFORMATION BE SHARED WITH?
					<br/>
					<br/>
					5. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
					<br/>
					<br/>
					6. IS YOUR INFORMATION TRANSFERRED INTERNATIONALLY?
					<br/>
					<br/>
					7. HOW LONG DO WE KEEP YOUR INFORMATION?
					<br/>
					<br/>
					8. HOW DO WE KEEP YOUR INFORMATION SAFE?
					<br/>
					<br/>
					9. DO WE COLLECT INFORMATION FROM MINORS?
					<br/>
					<br/>
					10. WHAT ARE YOUR PRIVACY RIGHTS?
					<br/>
					<br/>
					11. CONTROLS FOR DO-NOT-TRACK FEATURES
					<br/>
					<br/>
					12. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
					<br/>
					<br/>
					13. DO WE MAKE UPDATES TO THIS NOTICE?
					<br/>
					<br/>
					14. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					1. WHAT INFORMATION DO WE COLLECT?
					<br/>
					<br/>
					<br/>
					<br/>
					Personal information you disclose to us
					<br/>
					<br/>
					In Short:  We collect information that you provide to us.
					<br/>
					<br/>
					We collect personal information that you voluntarily provide to us when you express an interest in obtaining information about us or our products and Services, when you participate in activities on the Website or otherwise when you contact us.
					<br/>
					<br/>
					The personal information that we collect depends on the context of your interactions with us and the Website, the choices you make and the products and features you use. The personal information we collect may include the following:
					<br/>
					<br/>
					Personal Information Provided by You. We collect names; email addresses; and other similar information.
					<br/>
					<br/>
					All personal information that you provide to us must be true, complete and accurate, and you must notify us of any changes to such personal information.
					<br/>
					<br/>
					Information automatically collected
					<br/>
					<br/>
					In Short:  Some information — such as your Internet Protocol (IP) address and/or browser and device characteristics — is collected automatically when you visit our Website.
					<br/>
					<br/>
					We automatically collect certain information when you visit, use or navigate the Website. This information does not reveal your specific identity (like your name or contact information) but may include device and usage information, such as your IP address, browser and device characteristics, operating system, language preferences, referring URLs, device name, country, location, information about who and when you use our Website and other technical information. This information is primarily needed to maintain the security and operation of our Website, and for our internal analytics and reporting purposes.
					<br/>
					<br/>
					Like many businesses, we also collect information through cookies and similar technologies.
					<br/>
					<br/>
					The information we collect includes:
					Log and Usage Data. Log and usage data is service-related, diagnostic usage and performance information our servers automatically collect when you access or use our Website and which we record in log files. Depending on how you interact with us, this log data may include your IP address, device information, browser type and settings and information about your activity in the Website (such as the date/time stamps associated with your usage, pages and files viewed, searches and other actions you take such as which features you use), device event information (such as system activity, error reports (sometimes called 'crash dumps') and hardware settings).
					Device Data. We collect device data such as information about your computer, phone, tablet or other device you use to access the Website. Depending on the device used, this device data may include information such as your IP address (or proxy server), device application identification numbers, location, browser type, hardware model Internet service provider and/or mobile carrier, operating system configuration information.
					Location Data. We collect information data such as information about your device's location, which can be either precise or imprecise. How much information we collect depends on the type of settings of the device you use to access the Website. For example, we may use GPS and other technologies to collect geolocation data that tells us your current location (based on your IP address). You can opt out of allowing us to collect this information either by refusing access to the information or by disabling your Locations settings on your device. Note however, if you choose to opt out, you may not be able to use certain aspects of the Services.
					<br/>
					<br/>
					Information collected from other sources
					<br/>
					<br/>
					In Short:  We may collect limited data from public databases, marketing partners, and other outside sources.
					<br/>
					<br/>
					In order to enhance our ability to provide relevant marketing, offers and services to you and update our records, we may obtain information about you from other sources, such as public databases, joint marketing partners, affiliate programs, data providers, as well as from other third parties. This information includes mailing addresses, job titles, email addresses, phone numbers, intent data (or user behavior data), Internet Protocol (IP) addresses, social media profiles, social media URLs and custom profiles, for purposes of targeted advertising and event promotion.
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					2. HOW DO WE USE YOUR INFORMATION?
					<br/>
					<br/>
					In Short:  We process your information for purposes based on legitimate business interests, the fulfillment of our contract with you, compliance with our legal obligations, and/or your consent.
					<br/>
					<br/>
					We use personal information collected via our Website for a variety of business purposes described below. We process your personal information for these purposes in reliance on our legitimate business interests, in order to enter into or perform a contract with you, with your consent, and/or for compliance with our legal obligations. We indicate the specific processing grounds we rely on next to each purpose listed below.
					<br/>
					<br/>
					We use the information we collect or receive:
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					For other business purposes. We may use your information for other business purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Website, products, marketing and your experience. We may use and store this information in aggregated and anonymized form so that it is not associated with individual end users and does not include personal information. We will not use identifiable personal information without your consent.
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					3. WILL YOUR INFORMATION BE SHARED WITH ANYONE?
					<br/>
					<br/>
					In Short:  We only share information with your consent, to comply with laws, to provide you with services, to protect your rights, or to fulfill business obligations.
					<br/>
					<br/>
					We may process or share your data that we hold based on the following legal basis:
					Consent: We may process your data if you have given us specific consent to use your personal information in a specific purpose.
					<br/>
					<br/>
					Legitimate Interests: We may process your data when it is reasonably necessary to achieve our legitimate business interests.
					<br/>
					<br/>
					Performance of a Contract: Where we have entered into a contract with you, we may process your personal information to fulfill the terms of our contract.
					<br/>
					<br/>
					Legal Obligations: We may disclose your information where we are legally required to do so in order to comply with applicable law, governmental requests, a judicial proceeding, court order, or legal process, such as in response to a court order or a subpoena (including in response to public authorities to meet national security or law enforcement requirements).
					<br/>
					<br/>
					Vital Interests: We may disclose your information where we believe it is necessary to investigate, prevent, or take action regarding potential violations of our policies, suspected fraud, situations involving potential threats to the safety of any person and illegal activities, or as evidence in litigation in which we are involved.
					More specifically, we may need to process your data or share your personal information in the following situations:
					<br/>
					<br/>
					Business Transfers. We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.
					Vendors, Consultants and Other Third-Party Service Providers. We may share your data with third-party vendors, service providers, contractors or agents who perform services for us or on our behalf and require access to such information to do that work. Examples include: payment processing, data analysis, email delivery, hosting services, customer service and marketing efforts. We may allow selected third parties to use tracking technology on the Website, which will enable them to collect data on our behalf about how you interact with our Website over time. This information may be used to, among other things, analyze and track data, determine the popularity of certain content, pages or features, and better understand online activity. Unless described in this notice, we do not share, sell, rent or trade any of your information with third parties for their promotional purposes. We have contracts in place with our data processors, which are designed to help safegaurd your personal information. This means that they cannot do anything with your personal information unless we have instructed them to do it. They will also not share your personal information with any organization apart from us. They also commit to protect the data they hold on our behalf and to retain it for the period we instruct.
					<br/>
					<br/>
					<br/>
					<br/>
					4. WHO WILL YOUR INFORMATION BE SHARED WITH?
					<br/>
					<br/>
					In Short:  We only share information with the following third parties.
					<br/>
					<br/>
					We only share and disclose your information with the following third parties. We have categorized each party so that you may easily understand the purpose of our data collection and processing practices. If we have processed your data based on your consent and you wish to revoke your consent, please contact us using the contact details provided in the section below titled "HOW CAN YOU CONTACT US ABOUT THIS NOTICE?".
					Web and Mobile Analytics
					Google Analytics
					<br/>
					<br/>
					<br/>
					<br/>
					5. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
					In Short:  We may use cookies and other tracking technologies to collect and store your information.
					<br/>
					<br/>
					We may use cookies and similar tracking technologies (like web beacons and pixels) to access or store information. Specific information about how we use such technologies and how you can refuse certain cookies is set out in our Cookie Notice.
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					6. IS YOUR INFORMATION TRANSFERRED INTERNATIONALLY?
					<br/>
					<br/>
					In Short:  We may transfer, store, and process your information in countries other than your own.
					<br/>
					<br/>
					Our servers are located in Germany, Singapore, United States, Brazil, and Australia. If you are accessing our Website from outside Germany, Singapore, United States, Brazil, and Australia, please be aware that your information may be transferred to, stored, and processed by us in our facilities and by those third parties with whom we may share your personal information (see "WILL YOUR INFORMATION BE SHARED WITH ANYONE?" above), in United States, and other countries.
					<br/>
					<br/>
					If you are a resident in the European Economic Area, then these countries may not necessarily have data protection laws or other similar laws as comprehensive as those in your country. We will however take all necessary measures to protect your personal information in accordance with this privacy notice and applicable law.
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					7. HOW LONG DO WE KEEP YOUR INFORMATION?
					<br/>
					<br/>
					In Short:  We keep your information for as long as necessary to fulfill the purposes outlined in this privacy notice unless otherwise required by law.
					<br/>
					<br/>
					We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy notice, unless a longer retention period is required or permitted by law (such as tax, accounting or other legal requirements). No purpose in this notice will require us keeping your personal information for longer than 6 months.
					<br/>
					<br/>
					When we have no ongoing legitimate business need to process your personal information, we will either delete or anonymize such information, or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely store your personal information and isolate it from any further processing until deletion is possible.
					<br/>
					<br/>
					<br/>
					<br/>
					8. HOW DO WE KEEP YOUR INFORMATION SAFE?
					<br/>
					<br/>
					In Short:  We aim to protect your personal information through a system of organizational and technical security measures.
					<br/>
					<br/>
					We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security, and improperly collect, access, steal, or modify your information. Although we will do our best to protect your personal information, transmission of personal information to and from our Website is at your own risk. You should only access the Website within a secure environment.
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					9. DO WE COLLECT INFORMATION FROM MINORS?
					<br/>
					<br/>
					In Short:  We do not knowingly collect data from or market to children under 18 years of age.
					<br/>
					<br/>
					We do not knowingly solicit data from or market to children under 18 years of age. By using the Website, you represent that you are at least 18 or that you are the parent or guardian of such a minor and consent to such minor dependent’s use of the Website. If we learn that personal information from users less than 18 years of age has been collected, we will deactivate the account and take reasonable measures to promptly delete such data from our records. If you become aware of any data we may have collected from children under age 18, please contact us at me@edvard.dev.
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					10. WHAT ARE YOUR PRIVACY RIGHTS?
					<br/>
					<br/>
					In Short:  In some regions, such as the European Economic Area, you have rights that allow you greater access to and control over your personal information. You may review, change, or terminate your account at any time.
					<br/>
					<br/>
					In some regions (like the European Economic Area), you have certain rights under applicable data protection laws. These may include the right (i) to request access and obtain a copy of your personal information, (ii) to request rectification or erasure; (iii) to restrict the processing of your personal information; and (iv) if applicable, to data portability. In certain circumstances, you may also have the right to object to the processing of your personal information. To make such a request, please use the contact details provided below. We will consider and act upon any request in accordance with applicable data protection laws.
					<br/>
					<br/>
					If we are relying on your consent to process your personal information, you have the right to withdraw your consent at any time. Please note however that this will not affect the lawfulness of the processing before its withdrawal, nor will it affect the processing of your personal information conducted in reliance on lawful processing grounds other than consent.
					<br/>
					<br/>
					If you are resident in the European Economic Area and you believe we are unlawfully processing your personal information, you also have the right to complain to your local data protection supervisory authority. You can find their contact details here: http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm.
					<br/>
					<br/>
					If you are resident in Switzerland, the contact details for the data protection authorities are available here: https://www.edoeb.admin.ch/edoeb/en/home.html.
					<br/>
					<br/>
					<br/>
					<br/>
					Cookies and similar technologies: Most Web browsers are set to accept cookies by default. If you prefer, you can usually choose to set your browser to remove cookies and to reject cookies. If you choose to remove cookies or reject cookies, this could affect certain features or services of our Website. To opt-out of interest-based advertising by advertisers on our Website visit http://www.aboutads.info/choices/.
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					11. CONTROLS FOR DO-NOT-TRACK FEATURES
					<br/>
					<br/>
					Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track (“DNT”) feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. At this stage, no uniform technology standard for recognizing and implementing DNT signals has been finalized. As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this privacy notice.
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					12. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
					<br/>
					<br/>
					In Short:  Yes, if you are a resident of California, you are granted specific rights regarding access to your personal information.
					<br/>
					<br/>
					California Civil Code Section 1798.83, also known as the “Shine The Light” law, permits our users who are California residents to request and obtain from us, once a year and free of charge, information about categories of personal information (if any) we disclosed to third parties for direct marketing purposes and the names and addresses of all third parties with which we shared personal information in the immediately preceding calendar year. If you are a California resident and would like to make such a request, please submit your request in writing to us using the contact information provided below.
					<br/>
					<br/>
					If you are under 18 years of age, reside in California, and have a registered account with the Website, you have the right to request removal of unwanted data that you publicly post on the Website. To request removal of such data, please contact us using the contact information provided below, and include the email address associated with your account and a statement that you reside in California. We will make sure the data is not publicly displayed on the Website, but please be aware that the data may not be completely or comprehensively removed from all our systems (e.g. backups, etc.).
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					13. DO WE MAKE UPDATES TO THIS NOTICE?
					<br/>
					<br/>
					In Short:  Yes, we will update this notice as necessary to stay compliant with relevant laws.
					<br/>
					<br/>
					We may update this privacy notice from time to time. The updated version will be indicated by an updated “Revised” date and the updated version will be effective as soon as it is accessible. If we make material changes to this privacy notice, we may notify you either by prominently posting a notice of such changes or by directly sending you a notification. We encourage you to review this privacy notice frequently to be informed of how we are protecting your information.
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					14. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
					<br/>
					<br/>
					If you have questions or comments about this notice, you may email us at me@edvard.dev or by post to:
					<br/>
					<br/>
					Edvard.dev
					<br>
					__________
					<br>
					__________
					<br>
					Finland
					<br/>
					<br/>
					<br/>
					<br/>
					HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?
					<br/>
					<br/>
					Based on the applicable laws of your country, you may have the right to request access to the personal information we collect from you, change that information, or delete it in some circumstances. To request to review, update, or delete your personal information, please visit: https://edvard.dev#contact. We will respond to your request within 30 days.
					<br/>
					<br/>
					This privacy policy was created using Termly’s Privacy Policy Generator.
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'PrivacyPolicy',
	}
</script>

<style scoped>
	.inner {
		display: flex;
		align-items: center;
	}

	p {
		overflow-x: hidden;
	}
</style>
